export default [
  { family: 'Gilmer', variants: ['300', 'regular', '500', '700'] },
  { family: 'Inter', variants: ['300', 'regular', '500', '700'] },
];
